import * as React from 'react';
import { PortalContext } from '../../../../context/portal-context';
import { Environment } from '../../../../enviroment';
import { useTrackingManager } from '../../../../tracking/use-tracking-manager';
import { formatOwnership } from '../../../../tracking/tracking-helper';
import { vwDataRedirect } from '../../../../helpers/VouchersHelper';
import { isVehicle } from '../../../../helpers/common-helpers';
import { VouchersCard } from './vouchers-card';
import { NormalizedVoucher, VoucherStatus, VoucherTypeEnum } from '@esportal/portal-service';

export const VouchersCtr: React.FC<{
	voucher: NormalizedVoucher;
	showButton?: boolean;
	voucherType: VoucherTypeEnum;
	setVouchersPopupData: React.Dispatch<React.SetStateAction<NormalizedVoucher | undefined>>;
	setIsVouchersPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ voucher, showButton = true, voucherType, setVouchersPopupData, setIsVouchersPopupVisible }) => {
	const { navigationService, userInteractionService, portalService } = React.useContext(PortalContext);
	const trackingManager = useTrackingManager();

	const shouldDisplayGetButton = (voucher: NormalizedVoucher): boolean => {
		let result = true;

		switch (voucher.status) {
			case VoucherStatus.ENJOYED:
			case VoucherStatus.NO_EXPIRATION:
			case VoucherStatus.TO_ENJOY:
			case VoucherStatus.TO_ENJOY_SOON:
				result = true;
				break;
			case VoucherStatus.EXPIRED:
				result = false;
				break;
		}
		return result;
	};

	const handleClickVoucher = () => {
		const vehicle = voucher?.vin ? portalService.getVehicleOrOrderByVin(voucher.vin).getValue() : null;
		const trackingVehicle = isVehicle(vehicle) ? vehicle : null;
		trackingManager.trackClubVWButtonClick(
			'Vouchers',
			{ contentId: `Voucher type ${voucherType}: ${voucher.card.title}` },
			{ vehicle: trackingVehicle ? formatOwnership([trackingVehicle]) : [] },
		);

		if (voucher.source === 'vwData') {
			if (voucher.layer) {
				setVouchersPopupData(voucher);
				setIsVouchersPopupVisible(true);
			} else {
				vwDataRedirect(voucher, navigationService, userInteractionService);
			}
		} else if (voucher.source === 'salesforce') {
			const environmentPath = Environment.getInstance().vouchersDetailPageId as string;
			const search = window.location.search;
			const target = navigationService.navigateTo(environmentPath, {});
			if (target) {
				target.push();
				const href = target.createHref();
				addParamToUrl(href, voucher.id, search);
			} else {
				console.log('detail page not created');
			}
		} else {
			console.error('voucher source error');
		}
	};

	const addParamToUrl = (href: string, param: string, search: string) => {
		const newSearchParams = new URLSearchParams(search);
		newSearchParams.append('voucher-id', param);
		window.history.replaceState(null, '', href + `?${newSearchParams.toString()}`);
	};

	return (
		<VouchersCard
			voucher={voucher}
			shouldDisplayGetButton={shouldDisplayGetButton(voucher)}
			handleClickVoucher={handleClickVoucher}
			showButton={showButton}
		/>
	);
};
